// AUTO-GENERATED GraphQL Builder for BookingCancellation
import * as Builders from '../';
export class BookingCancellationBuilder {
  private s:string[]=[]; private r:string[]=[]; private v=new Set<string>(); depth=0;
  private add(f:string){ if(!this.s.includes(f)) this.s.push(f); return this; }
  getSelections(){ return [...this.s]; }
  toSelectionSet(){ const a=[...this.s,...this.r]; if(!a.length)return`{ id }`; return`{\n  ${a.join("\n  ")}\n}`;}
  guid(){ return this.add('guid'); }
  bookingId(){ return this.add('bookingId'); }
  cancelledBy(){ return this.add('cancelledBy'); }
  reason(){ return this.add('reason'); }
  stageAtCancel(){ return this.add('stageAtCancel'); }
  heldAtCancel(){ return this.add('heldAtCancel'); }
  refundAmount(){ return this.add('refundAmount'); }
  vendorKeepAmount(){ return this.add('vendorKeepAmount'); }
  forfeitAmount(){ return this.add('forfeitAmount'); }
  forfeitDestination(){ return this.add('forfeitDestination'); }
  feeRefundAmount(){ return this.add('feeRefundAmount'); }
  feeKeptAmount(){ return this.add('feeKeptAmount'); }
  advanceOutstanding(){ return this.add('advanceOutstanding'); }
  clawbackAmount(){ return this.add('clawbackAmount'); }
  fundOwedAmount(){ return this.add('fundOwedAmount'); }
  fundCoverAmount(){ return this.add('fundCoverAmount'); }
  cancelledDate(){ return this.add('cancelledDate'); }
  id(){ return this.add('id'); }
  isDeleted(){ return this.add('isDeleted'); }
  createdBy(){ return this.add('createdBy'); }
  createdDate(){ return this.add('createdDate'); }
  updatedBy(){ return this.add('updatedBy'); }
  updatedDate(){ return this.add('updatedDate'); }

  booking(b?:(q:Builders.BookingBuilder)=>void){
    if(this.depth>=5||this.v.has('booking'))return this;
    this.v.add('booking');
    const n=new Builders.BookingBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`booking { ${inner} }`);
    return this;
  }

  createdByUser(b?:(q:Builders.UserBuilder)=>void){
    if(this.depth>=5||this.v.has('createdByUser'))return this;
    this.v.add('createdByUser');
    const n=new Builders.UserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`createdByUser { ${inner} }`);
    return this;
  }

  updatedByUser(b?:(q:Builders.UserBuilder)=>void){
    if(this.depth>=5||this.v.has('updatedByUser'))return this;
    this.v.add('updatedByUser');
    const n=new Builders.UserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`updatedByUser { ${inner} }`);
    return this;
  }
}
